import { useEffect, useState } from "react";
import { Box, Grid, ThemeProvider, Typography } from "@material-ui/core/";
import LoginImg from "../../../assets/img_login.png";
import { Redirect, useHistory } from "react-router-dom";
import { ReactComponent as BrandSirioIcon } from "../../../assets/brands/brand_sirio.svg";
import { CustomDefaultTheme } from "../../../themes/CustomDefault";
import { useAuthContext } from "../../../context/AuthContext";
import FormBase from "../../../forms/FormBase";
import { Alert } from "@material-ui/lab";
import TmpTypographyCustom from "../../../components/tempo/TmpTypographyCustom/TmpTypographyCustom";
import TmpButtonCustom from "../../../components/tempo/TmpButtonCustom/TmpButtonCustom";
import TmpInputCustom from "../../../components/tempo/TmpInputCustom/TmpInputCustom";
import TmpLinkCustom from "../../../components/tempo/TmpLinkCustom/TmpLinkCustom";
import TmpBrandingCustom from "../../../components/tempo/TmpBrandingCustom/TmpBrandingCustom";
import TmpAlertCustom from "../../../components/tempo/TmpAlertCustom/TmpAlertCustom";

export default function Login() {

    const { login, isAuthenticated, state, dispatch } = useAuthContext();

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string>('')
    const [isOpenAlert, setIsOpenAlert] = useState<boolean>(false)
    const [messageAlert, setMessageAlert] = useState<string>("")

    let history = useHistory();

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, []);

    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search)
        const expirado = queryParameters.get("expirado")

        if(expirado === "true"){
            setMessageAlert("Seu login expirou. Por segurança, realize o login novamente para continuar.")
            setIsOpenAlert(true);
        }
    }, [])

    // useEffect(() => {
    //     setErrorMessage("");
    //   }, [state.LoginForm.Login, state.LoginForm.Senha])

    const handleLogin = async () => {

        setIsLoading(true);

        //Verifica se todos os campos estão preenchidos
        if (!state.LoginForm.ValidateForm()) {

            //Realiza a atualização de todos os campos
            dispatch({
                type: "VALIDATE_FORM",
                payload: { form: state.LoginForm },
            });

            setIsLoading(false);
            return;
        }

        const result = await login(state.LoginForm.Login.Value, state.LoginForm.Senha.Value);

        if (result === undefined) {
            history.push("/userhome");
        } else {
            setErrorMessage(result);
            setIsLoading(false);
        }
    }

    if (isAuthenticated) {
        return <Redirect to='/userhome' />
    } else {
        return (

            <ThemeProvider theme={CustomDefaultTheme}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ backgroundColor: "#e8f3fe", display: "inline-block", flexGrow: 1, flexBasis: 0, height: "100vh" }} ></div>
                    <div style={{ display: "inline-block", width: "1210px", height: "100vh" }} >

                        <Grid container >

                            <Grid item xs={6}>
                                <Box style={{ backgroundColor: "#e8f3fe" }} display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                                    <img src={LoginImg} width="80%" alt="Logo" />
                                </Box>
                            </Grid>

                            <Grid item xs={6} >
                                <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" ml="10%" mr="10%" >
                                    <Grid container spacing={3}   >
                                        <Grid item xs={12} sm={12} >
                                            <Typography style={{ fontSize: "3.375rem", fontWeight: "700", fontFamily: "Inter,sans-serif", lineHeight: "1.1" }} >
                                                Serviço de <br /> Apoio ao   Médico
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} >
                                            <TmpTypographyCustom component="paragraph" size="medium" id="texto-boas-vindas">
                                                Bem-vindo(a) ao portal do SAM - Serviço de Apoio ao Médico do Hospital Sírio-Libanês.
                                            </TmpTypographyCustom>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box>
                                                <Grid container spacing={1} >
                                                    <Grid item xs={12} sm={12} >
                                                        <TmpInputCustom
                                                            name="Usuario"
                                                            id="login-usuario"
                                                            label="Usuário *"
                                                            type="text"
                                                            placeholder={"Informe o seu usuário"}
                                                            value={state.LoginForm.Login.Value}
                                                            onChange={(e) => { onInputChange("Login", state.LoginForm, e.target.value) }}
                                                            onBlur={(e) => { onInputChange("Login", state.LoginForm, e.target.value) }}
                                                            helperText={state.LoginForm.Login.Error}
                                                            error={state.LoginForm.Login.HasError()}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} >
                                                        <TmpInputCustom
                                                            name="Senha"
                                                            id="senha-usuario"
                                                            label="Senha *"
                                                            type={"password"}
                                                            placeholder={"Informe a sua senha"}
                                                            value={state.LoginForm.Senha.Value}
                                                            onChange={(e) => { onInputChange("Senha", state.LoginForm, e.target.value) }}
                                                            onBlur={(e) => { onInputChange("Senha", state.LoginForm, e.target.value) }}
                                                            helperText={state.LoginForm.Senha.Error}
                                                            error={state.LoginForm.Senha.HasError()}
                                                        />
                                                    </Grid>

                                                    {errorMessage !== '' ?
                                                        (
                                                            <Grid item xs={12} sm={12}>
                                                                <Alert severity="error">{errorMessage}</Alert>
                                                            </Grid>
                                                        ) : null
                                                    }

                                                    <Grid item xs={12} sm={12}>
                                                        <Box textAlign="center">

                                                            <TmpButtonCustom
                                                                loading={isLoading}
                                                                widthFull={true}
                                                                type="primary"
                                                                typeButton="button"
                                                                size="lg"
                                                                handleClick={handleLogin}>
                                                                    Acessar
                                                            </TmpButtonCustom>

                                                        </Box>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12}>
                                                        <Box mt={2} >
                                                            <TmpLinkCustom href='/'>
                                                                Voltar
                                                            </TmpLinkCustom>
                                                            <TmpBrandingCustom logo={<BrandSirioIcon />} />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>

                    </div>
                    <div style={{ display: "inline-block", flexGrow: 1, flexBasis: 0 }} ></div>

                </div>
                <TmpAlertCustom isOpened={isOpenAlert} message={messageAlert} title="Atenção" type="error"></TmpAlertCustom>
            </ThemeProvider >
        );
    }
}
